/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Records_Table_LabelInputs */



/**
* | output |
* | --- |
* | "Auto Save Records Table" |
*
* @param {Automatic_Save_Records_Table_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_records_table_label = /** @type {((inputs?: Automatic_Save_Records_Table_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Records_Table_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tableau des enregistrements de sauvegarde automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tabelle zum automatischen Speichern von Datensätzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tabella dei record di salvataggio automatico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Таблица автоматического сохранения записей")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tabla de registros guardados automáticamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动保存记录表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動保存レコードテーブル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्ड तालिका को स्वतः सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tabela de registros de salvamento automático")
	return /** @type {LocalizedString} */ ("Auto Save Records Table")
});